import './UserNotAllowedToAccessApp.css';

import { Alert, AlertItem, Button } from '@vmware-react/clarity';
import React, { useCallback, useState } from 'react';

import { AsyncOpState } from 'vrlcm-gui-types';
import { AuthApi } from 'vrlcm-gui-api';
import { redirectToLoginPage } from 'vrlcm-gui-utils';
import { l10n } from '../i18n/i18nUtil';

const UserNotAllowedToAccessApp: React.FC<{ errorMessage?: string }> = ({
  errorMessage
}) => {
  const [logoutApiState, setLogoutApiState] = useState<AsyncOpState>(
    AsyncOpState.NotStarted
  );

  const onLogout = useCallback(() => {
    setLogoutApiState(AsyncOpState.Inprogress);
    AuthApi.logout().then(
      () => redirectToLoginPage(),
      () => redirectToLoginPage()
    );
  }, []);
  return (
    <div className="user-not-allowed-to-access-app">
      <Alert
        ariaLiveMsg={errorMessage}
        type="danger"
        items={[<AlertItem>{errorMessage}</AlertItem>]}
      />
      <Button
        class="primary"
        onClick={onLogout}
        disabled={logoutApiState === AsyncOpState.Inprogress}
      >
        {l10n('logout')}
      </Button>
    </div>
  );
};

export default UserNotAllowedToAccessApp;
